





























































































































import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import { renderMedicineHtml } from "./medicineTextConverter";

interface ProductSearchResultView {
  product_id: string;
  product_name: string;
  generic_name: string;
  category: string;
  unit: string;
}

const LEAD_CHARS = new Set(["●", "○", "★", "◎"]);

const ICON_MAP: Record<string, string> = {
  "●": "ic_daihyo",
  "○": "ic_kouhatsu_a",
  "★": "ic_shinyaku",
  "◎": "ic_ag_c"
};

@Component
export default class MedicineProductSearchDialog extends Mixins(AxiosMixin) {
  @Prop({ default: false }) value!: boolean;

  private readonly displayLimit = 50;

  private internalValue = false;
  private searchQuery = "";
  private hasSearched = false;
  private searchResults: ProductSearchResultView[] = [];
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;
  private cancelSearch: (() => void) | null = null;

  get displayedResults(): ProductSearchResultView[] {
    return this.searchResults.slice(0, this.displayLimit);
  }

  private productLeadIcon(productName: string): string {
    const lead = productName.charAt(0);
    const icon = ICON_MAP[lead] || "ic_kouhatsu_b";
    return `/images/medicine/icon/${icon}.svg`;
  }

  private renderHtml(text: string): string {
    return renderMedicineHtml(text);
  }

  private stripLeadChar(productName: string): string {
    if (productName && LEAD_CHARS.has(productName.charAt(0))) {
      return productName.slice(1);
    }
    return productName;
  }

  @Watch("value")
  private onValueChanged(val: boolean) {
    this.internalValue = val;
    if (val) {
      this.searchQuery = "";
      this.hasSearched = false;
      this.searchResults = [];
    }
  }

  @Watch("searchQuery")
  private onSearchQueryChanged() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.performSearch();
    }, 300);
  }

  @Emit("input")
  private emitInput(val: boolean) {
    return val;
  }

  @Emit("open-product-detail")
  private emitOpenProductDetail(productId: string) {
    return productId;
  }

  private close() {
    if (this.cancelSearch) {
      this.cancelSearch();
      this.cancelSearch = null;
    }
    this.internalValue = false;
    this.emitInput(false);
  }

  private performSearch() {
    const trimmed = this.searchQuery ? this.searchQuery.trim() : "";
    if (!trimmed) {
      this.hasSearched = false;
      this.searchResults = [];
      return;
    }

    // 前のリクエストをキャンセルしてから新しいリクエストを発行
    if (this.cancelSearch) this.cancelSearch();
    this.cancelSearch = this.postJsonCheckCancelable(
      window.base_url + "/api/patient/medicine/products/search",
      { product_name: trimmed },
      res => {
        this.hasSearched = true;
        this.searchResults = res.data.products || [];
      }
    );
  }

  private selectItem(item: ProductSearchResultView) {
    this.emitOpenProductDetail(item.product_id);
  }
}
